import { UiOption } from '@/lib/helpers';
import { ClassifierModel, ClassifierSubType } from '../classifier';
import { PropModel } from '../prop.model';
import { ControlActionValue, ControlCategoryActionMapping, getSettingOptions } from './controls';

export type ClassifierEntity = {
  action: ControlActionValue;
  classifierId: string;
};

export class ClassifierControlConfig extends PropModel {
  entities: ClassifierEntity[];

  constructor(props?: Record<string, unknown>) {
    super();
    const data = (props || {}) as Record<keyof ClassifierControlConfig, unknown>;
    this.entities = (data.entities as ClassifierEntity[]) || [];
  }
}

export class RegexPatternConfig extends PropModel {
  entities: ClassifierEntity[];

  constructor(props?: Record<string, unknown>) {
    super();
    const data = (props || {}) as Record<keyof RegexPatternConfig, unknown>;
    this.entities = (data.entities as ClassifierEntity[]) || [];
  }
}

export type ClassifierControlSettings = {
  classifierId: string;
  label: string;
  description: string;
  actions: ControlActionValue[];
  defaultAction: ControlActionValue;
  enabled?: boolean;
};

export const ClassifierControlsSettings = (classifiers: ClassifierModel[]) => {
  return classifiers.map(
    ({ id, name, description, enabled, subtype }) =>
      ({
        classifierId: id,
        label: name,
        description,
        actions:
          subtype === ClassifierSubType.Regex
            ? ['ignore', 'log', 'warn', 'block', 'tag', 'mask', 'delete']
            : ['ignore', 'log', 'warn', 'block'],
        defaultAction: 'ignore',
        enabled,
      }) as ClassifierControlSettings
  );
};

export const getClassifierControlActionOptions = (
  classifiers: ClassifierModel[]
): Map<string, UiOption[]> => {
  const options: Map<string, UiOption[]> = new Map();

  ClassifierControlsSettings(classifiers).forEach(({ classifierId, actions }) => {
    const settingOptions: UiOption[] = [];

    ControlCategoryActionMapping.forEach(({ header, actions: categoryActions }) => {
      if (categoryActions.some((action) => actions.includes(action))) {
        settingOptions.push({
          label: header,
          value: header.toLowerCase(),
          meta: { header: true },
        });
        for (const action of categoryActions) {
          if (actions.includes(action)) {
            settingOptions.push(getSettingOptions(action, false));
          }
        }
      }
    });

    options.set(classifierId, settingOptions);
  });

  return options;
};
